import { BuildingRole } from '../../core-models';

export const BUILDING_ROLE_LABEL: Record<BuildingRole, string> = {
    [BuildingRole.BuildingViewOnly]: 'Building View Only',
    [BuildingRole.BuildingAgent]: 'Building Agent',
    [BuildingRole.BuildingOwner]: 'Building Manager',
};

export const BUILDING_ROLE_DESCRIPTION: Record<BuildingRole, string> = {
    [BuildingRole.BuildingOwner]:
        'Full building access. Can manage building content and building access for this building.',
    [BuildingRole.BuildingAgent]:
        'Can manage building content and operational data for this building. Cannot access building permissions.',
    [BuildingRole.BuildingViewOnly]:
        'Can view building content and operational data for this building. Cannot make changes.',
};

export function getBuildingRoleLabel(role: BuildingRole): string {
    return BUILDING_ROLE_LABEL[role] ?? '';
}
